import React from 'react';
import { BodyText as UiBodyText, BodyTextProps } from '@make-software/cspr-ui';

type Ref = HTMLSpanElement;

export const BodyText = React.forwardRef<Ref, BodyTextProps>(
  (props: BodyTextProps, ref) => (
    <UiBodyText ref={ref} scale={'xs'} lineHeight={'xs'} {...props} />
  )
);
